import { CalcCaseProperty, CaseDisplayGroupItem, CustomCaseProperty } from "generated/graphql";
import { stripNull } from "helpers/coll";
import { useCallback } from "react";

export enum CaseDisplayGroupItemSchemaType {
  Property = "property",
  Calc = "calc",
}

export function useFindSchemaForCaseDisplayGroupItem(
  calcSchemas: CalcCaseProperty[],
  casePropertySchemas: CustomCaseProperty[]
): (item: Omit<CaseDisplayGroupItem, "id" | "rank">) =>
  | ((CalcCaseProperty | CustomCaseProperty) & {
      schemaType: CaseDisplayGroupItemSchemaType;
    })
  | undefined {
  const findSchema = useCallback(
    (item: Omit<CaseDisplayGroupItem, "id" | "rank">) => {
      const calcKey = stripNull(item.caseCalcKey);
      const propKey = stripNull(item.casePropertyKey);

      if (calcKey !== undefined) {
        const found = calcSchemas.find((calc) => calc.key === calcKey);
        return found !== undefined
          ? {
              ...found,
              schemaType: CaseDisplayGroupItemSchemaType.Calc,
            }
          : undefined;
      } else if (propKey !== undefined) {
        const found = casePropertySchemas.find((cp) => cp.key === propKey);
        return found !== undefined
          ? {
              ...found,
              schemaType: CaseDisplayGroupItemSchemaType.Property,
            }
          : undefined;
      } else {
        return undefined;
      }
    },
    [casePropertySchemas, calcSchemas]
  );

  return findSchema;
}
